import Adb from "@mui/icons-material/Adb";
import { JSONTree } from "react-json-tree";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { type FC } from "react";
import toast from "react-hot-toast";
import { useFlags } from "../../../../server/optimizely";
import { useDialog } from "../../../../utils/hooks/use-dialog";
import type { FollowUpPageState } from "../../reducer/actions";

export const FollowUpDebugButton: FC<{
  state: FollowUpPageState;
}> = ({ state }) => {
  const {
    flags: { debug, debug_debug },
  } = useFlags("debug", "debug_debug");

  const dialog = useDialog();

  if (!debug) return null;

  return (
    <>
      <IconButton data-analytics-id="debug-follow-up-button" onClick={dialog.handleOpen}>
        <Adb />
      </IconButton>
      <Dialog open={dialog.open} onClose={dialog.handleClose} fullWidth>
        <DialogTitle>Debug</DialogTitle>
        <DialogContent>
          {debug_debug ? (
            <pre>{JSON.stringify(state, undefined, "  ")}</pre>
          ) : (
            <JSONTree data={state} />
          )}
        </DialogContent>
        <DialogActions>
          {/* Copy to clipboard */}
          <Button
            data-analytics-id="copy-follow-up-debug-button"
            onClick={() => {
              void navigator.clipboard.writeText(JSON.stringify(state, undefined, 2)).then(() => {
                toast("Copied to clipboard");
              });
            }}
          >
            Copy to clipboard
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
